import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import MenuObject from '../canvas/menu-object';
import * as actions from '../actions';
import store from '../store';
import util from '../util';
import { markAsModified } from "../canvas/mark-as-modified";
import MenuContentPrices from "./MenuContentPrices";
import MenuContentModifiers from "./MenuContentModifiers";
import constants from '../constants';
import Interactable from "../canvas/interactable";
import MenuIconEdit from './MenuIconEdit';
import MenuContentEditHighlight from './MenuContentEditHighlight';
import Quill from 'quill';
import { BoldOutlined, ItalicOutlined, MoreOutlined, UnderlineOutlined } from '@ant-design/icons';
import menuObject from '../canvas/menu-object';

const { dispatch } = store;
const { goToView, setSelectionType } = actions;

export default @connect(reduce, actions)
class MenuContentEditItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: props.active,
      activeIdx: props.activeIdx,
      activeIcons: props.active?.icons || [],
      activeIconIdx: 0,
      showDescriptionToolbar: false,
      showNameToolbar: false,
    };

    this.openColorPicker = () => {
      let type = [constants.pickerTypes.moIconFill, { active: this.state.active, activeIdx: this.state.activeIdx, activeIconIdx: this.state.activeIconIdx }]
      store.dispatch(actions.setIsLeftMenuVisible(true));
      util.openColorPicker(type, false);
      util.nextTick(() => {
        Interactable.adjustSelectionBoxes();
      });
    }

    this.setActiveIconIdx = (idx) => {
      this.setState({ activeIconIdx: idx });
    }

    this.toggleDescriptionToolbar = this.toggleDescriptionToolbar.bind(this);
  }

  updateItemValue(key, value, idx = -1) {
    const active = { ...this.state.active };

    if (idx > -1) {
      active[key][idx] = value;
    } else {
      active[key] = value;
    }
    const items = store.getState().menuObjectItems;
    items[this.props.activeIdx] = active;
    this.setState({ active });

    MenuObject.updateContent(this.props.$element, items, false, true, true);
  }

  removeItem(key, idx) {
    let active = { ...this.state.active };
    active.prices.splice(idx, 1);
    const items = store.getState().menuObjectItems;
    if (active.prices.length !== items[this.props.activeIdx].prices.length) {
      items[this.props.activeIdx].prices.splice(idx, 1);
    }

    if (active.prices.length === 1) {
      const json = JSON.parse(active.prices[0]);
      json.size = "";
      const stringified = JSON.stringify(json);
      active.prices[0] = stringified;
      items[this.props.activeIdx].prices[0] = stringified;
    }

    this.setState({ active });

    MenuObject.updateContent(this.props.$element, items, false, true, true);
  }

  removeItemModifier(key, idx) {
    let active = { ...this.state.active };
    active.modifiers.splice(idx, 1);
    const items = store.getState().menuObjectItems;
    if (active.modifiers.length !== items[this.props.activeIdx].modifiers.length) {
      items[this.props.activeIdx].modifiers.splice(idx, 1);
    }
    this.setState({ active });

    MenuObject.updateContent(this.props.$element, items, false, true, true);
  }

  editIcon(activeIdx, iconKey, iconType, color, altText="", source="") {
    let icons = !this.state.activeIcons ? [] : [...this.state.activeIcons];

    try {
      if (iconKey !== 'deleteIcon') {
        let activeIcon = icons[activeIdx] != null ? icons[activeIdx] : new MenuObject.MenuIcon();
        activeIcon.type = iconType;
        activeIcon.fill = color;
        activeIcon.altText = altText;
        activeIcon.source = source;

        if (iconType !== 'svg') {
          activeIcon.fill = color;
        }

        activeIcon.iconKey = iconKey;
        if (activeIdx >= 0) {
          icons[activeIdx] = activeIcon;
        } else if (icons.length < constants.maxMenuItemIcons) {
          icons[icons.length] = activeIcon;
        }

        if (iconType === 'letter') {
          if (!this.props.menuObjectStyles['icon-entry'] || !this.props.menuObjectStyles['icon-entry']['font-family']) {
            menuObject.applyLetterIconDefaultStyles(this.props.$element);
          }
        }
      } else {
        icons[activeIdx] = null;
        icons = icons.filter(icon => icon !== null);
      }
      this.state.active.icons = icons;
      this.setState({ activeIcons: icons });
      const items = store.getState().menuObjectItems;
      items[this.props.activeIdx] = this.state.active;
      MenuObject.updateContent(this.props.$element, items, false, false);
      MenuObject.findMenuActiveIcons();
    } catch (err) {
      console.log(err.stack);
    }
  }

  clearAllIcons() {
    this.state.active.icons = [];
    this.setState({ activeIcons: [] });
    const items = store.getState().menuObjectItems;
    items[this.props.activeIdx] = this.state.active;
    MenuObject.updateContent(this.props.$element, items, false, false);
    MenuObject.findMenuActiveIcons();
  }

  goToEditIcons(idx) {
    this.props.setContentEditMode('icons');
    this.setActiveIconIdx(idx);
  }

  save() {
    MenuObject.updateContent(this.props.$element, store.getState().menuObjectItems, false, true);
  }

  onExtrasKeydown(e) {
    if (e.key === 'Tab') {
      e.preventDefault();
      e.stopPropagation();
      document.querySelectorAll('.item-details .name.field')[0].focus();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.contentEditMode !== 'item' && nextProps.contentEditMode === 'item') {
      util.nextTick(() => {
        this.initializeTextEditors();
      })
    }
  }

  initializeTextEditors() {
    $('#descriptionEditor').html(this.state.active?.description);
    const descEditable = new Quill('#descriptionEditor', {
      modules: {
        toolbar: '#descriptionToolbar',
        keyboard: {
          bindings: {
            tab: { key: 9, handler: function () { return true; } },
            list: {
              key: 'backspace', context: { format: ['list'] },
              handler: function (range, context) {
                if (range.length === 0 && range.index !== 0) {
                  this.quill.deleteText(range.index - 1, 1, Quill.sources.USER);
                } else {
                  this.quill.deleteText(range, Quill.sources.USER);
                }
              }
            }
          }
        },
      },
      formats: ['bold', 'italic', 'underline'],
    });
    descEditable.on('text-change', this.onTextChange.bind(descEditable, this, 'description'));
    $(descEditable.container).find('.ql-editor').on('paste cut', (e) => {
      this.onPasteCut(e, 'description');
    })
    $(descEditable.getModule("toolbar").container).on('mousedown', (e) => {
      e.preventDefault();
    });
    const $descQlEditor = $('#descriptionEditor .ql-editor');
    $descQlEditor.attr('tabindex', '3');
    $descQlEditor.on('focus', () => {
      $('#descriptionEditor').addClass('focused');
    });
    $descQlEditor.on('blur', () => {
      $('#descriptionEditor').removeClass('focused');
      this.setState({ showDescriptionToolbar: false })
    });

    $('#nameEditor').html(this.state.active?.name);
    const nameEditable = new Quill('#nameEditor', {
      modules: {
        toolbar: '#nameToolbar',
        keyboard: {
          bindings: {
            tab: { key: 9, handler: function () { return true; } },
            list: {
              key: 'backspace', context: { format: ['list'] },
              handler: function (range, context) {
                if (range.length === 0 && range.index !== 0) {
                  this.quill.deleteText(range.index - 1, 1, Quill.sources.USER);
                } else {
                  this.quill.deleteText(range, Quill.sources.USER);
                }
              }
            }
          }
        }
      },
      formats: ['bold', 'italic', 'underline'],
    });
    nameEditable.on('text-change', this.onTextChange.bind(nameEditable, this, 'name'));
    $(nameEditable.container).find('.ql-editor').on('paste cut', (e) => {
      this.onPasteCut(e, 'name');
    })
    $(nameEditable.getModule("toolbar").container).on('mousedown', (e) => {
      e.preventDefault();
    });
    const $nameQlEditor = $('#nameEditor .ql-editor');
    $nameQlEditor.attr('tabindex', '3');
    $nameQlEditor.on('focus', () => {
      $('#nameEditor').addClass('focused');
    });
    $nameQlEditor.on('blur', () => {
      $('#nameEditor').removeClass('focused');
      this.setState({ showNameToolbar: false })
    });
    nameEditable.setSelection(nameEditable.getLength(), 0);
    $nameQlEditor.trigger('focus');
  }

  componentDidMount() {
    if (!this.props.$element) return;
    MenuObject.updateContent(this.props.$element, store.getState().menuObjectItems, false, true, true, false);

    util.nextTick(() => {
      this.input?.focus();
      this.initializeTextEditors();
    }, 100);
  }

  componentWillUnmount() {
    if (this.props.$element) MenuObject.fixLineHeights(this.props.$element, true);
  }

  translateHTMLForCanvas(html) {
    return html.replaceAll('</p><p', '<br></p><p').replaceAll('<br><br></p><p', '<br></p><p');
  }

  onTextChange(this1, field) {
    this1.updateTextOnCanvas($(this.container).find('.ql-editor')[0], field);
  }

  onPasteCut(e, field) {
    this.updateTextOnCanvas($(e.currentTarget)[0], field);
  }

  updateTextOnCanvas(qlElement, field) {
    let toSetHTML = '';
    const blankValues = ['', '\n'];
    let innerText = qlElement.innerText;
    if (!blankValues.includes(innerText)) {
      toSetHTML = this.translateHTMLForCanvas(qlElement.innerHTML);
    }
    this.updateItemValue(field, toSetHTML);
  }

  toggleDescriptionToolbar(ev) {
    ev.stopPropagation();
    if (!this.state.showDescriptionToolbar) {
      $('#descriptionEditor .ql-editor').trigger('focus');
    }
    this.setState({ showDescriptionToolbar: !this.state.showDescriptionToolbar });
  }

  toggleNameToolbar(ev) {
    ev.stopPropagation();
    if (!this.state.showNameToolbar) {
      $('#nameEditor .ql-editor').trigger('focus');
    }
    this.setState({ showNameToolbar: !this.state.showNameToolbar });
  }

  onBinUpdate(value) {
    if (!this.props.menuObjectStyles['bin'] || !this.props.menuObjectStyles['bin']['font-family'] || !this.props.menuObjectStyles['bin-header'] || !this.props.menuObjectStyles['bin-header']['font-family']) {
      menuObject.applyNameStylesToBin(this.props.$element);
    }
    this.updateItemValue('bin', value);
  }

  onBinHeaderUpdate(value) {
    if (!this.props.menuObjectStyles['bin'] || !this.props.menuObjectStyles['bin']['font-family'] || !this.props.menuObjectStyles['bin-header'] || !this.props.menuObjectStyles['bin-header']['font-family']) {
      menuObject.applyNameStylesToBin(this.props.$element);
    }
    this.updateItemValue('binHeader', value);
  }

  editNameNotes() {
    store.dispatch(actions.setMOEditMode('name-notes'));
  }

  render(props, state) {
    if (store.getState().isMobileVersion && props.activeIdx !== state.activeIdx) {
      this.setState({ active: props.active, activeIcons: props.active.icons, activeIdx: props.activeIdx })
    }

    const iconEntryColor = props.menuObjectStyles && props.menuObjectStyles['icon-entry'] ? props.menuObjectStyles['icon-entry']['color'] : '';

    return (
      <div className="no-drag modal-content">
        <div className="modal-content-edit">
          <div className={`item-details scroller ${props.contentEditMode === 'icons' ? 'edit-icons' : ''}`}>
            {props.contentEditMode === 'item' && <div>
              <div className="name-notes-btn" onClick={() => this.editNameNotes()}>Group Header</div>

              <div className={`bin-name-container ${props.menuObjectLayout.indexOf('bin') > -1 && props.menuObjectLayout.indexOf('header') > -1 ? 'has-bin-header' : ''}`}>
                {props.menuObjectLayout.indexOf('bin') > -1 && props.menuObjectLayout.indexOf('header') > -1 &&
                  <div className={"bin-header"}>
                    <textarea tabIndex={1} placeholder="BIN Header" className="field bin-header" spellcheck="true" autocomplete="off"
                      value={state.active?.binHeader?.replace('&nbsp;', '')}
                      ref={(input) => { this.input = input; }}
                      onChange={e => {
                        this.onBinHeaderUpdate(e.target.value);
                      }} />
                  </div>}

                {props.menuObjectLayout.indexOf('bin') > -1 &&
                  <div className={"bin"}>
                    <textarea tabIndex={1} placeholder="BIN" className="field bin" spellcheck="true" autocomplete="off"
                      value={state.active?.bin?.replace('&nbsp;', '')}
                      ref={(input) => { this.input = input; }}
                      onChange={e => {
                        this.onBinUpdate(e.target.value);
                      }} />
                  </div>}

                <div className={'field name'}
                  id='nameEditor'
                >
                </div>

                <div className={`toggle-name-toolbar ${state.showNameToolbar ? 'active' : ''}`} onMouseDown={(ev) => ev.preventDefault()} onClick={(ev) => this.toggleNameToolbar(ev)}>
                  <MoreOutlined />
                </div>
                <div id="nameToolbar" className={state.showNameToolbar ? 'show' : ''}>
                  <button class="ql-bold"><BoldOutlined /></button>
                  <button class="ql-italic"><ItalicOutlined /></button>
                  <button class="ql-underline"><UnderlineOutlined /></button>
                </div>
              </div>

              <div className="iconsContainer">
                <div className="iconsList">
                  <ul>
                    {state.activeIcons.map(icon => {
                      return (
                        <li onClick={() => this.goToEditIcons(state.activeIcons.indexOf(icon))}>
                          {
                            icon.type === 'svg' ?
                              <svg className="icon-entry" width="28px" height="28px" fill={icon.fill ? icon.fill : iconEntryColor}>
                                <use xlinkHref={constants.appPrefix + '/svg/icon-library/menu-icons.svg#' + icon.iconKey}> </use>
                              </svg>
                            : icon.type === 'letter' ?
                            <span className="icon-entry" width="28px" height="28px" style={`color: ${icon.fill ? icon.fill : iconEntryColor};`}>
                              {icon.iconKey}
                            </span>
                            : icon.iconKey.includes("icon-uploads") ?
                              <img className="icon-entry" width="28px" height="28px" src={util.getUploadedIconPath(icon)} />
                              :
                              <img className="icon-entry" width="28px" height="28px" src={constants.SECURE_S3_OO_PATH + icon.iconKey} />
                          }
                        </li>
                      )
                    })}
                    {state.activeIcons.length < constants.maxMenuItemIcons &&
                      <li className="add-icon" onClick={() => this.goToEditIcons(null)}>
                        <span>+ Icon</span>
                      </li>}
                  </ul>
                </div>
              </div>

              <textarea
                tabIndex={2}
                placeholder="Menu Tag"
                className={`field tag ${props.$element.attr('data-show-tag') === "true" ? '' : 'hidden'}`}
                spellcheck="true"
                autocomplete="off"
                value={state.active?.tag?.replace('&nbsp;', '')}
                onChange={e => {
                  this.updateItemValue('tag', e.target.value);
                }}
              />

              <div className={'field description'}
                id='descriptionEditor'
              >
              </div>

              <div className={`toggle-description-toolbar ${state.showDescriptionToolbar ? 'active' : ''}`} onMouseDown={(ev) => ev.preventDefault()} onClick={(ev) => this.toggleDescriptionToolbar(ev)}>
                <MoreOutlined />
              </div>
              <div id="descriptionToolbar" className={state.showDescriptionToolbar ? 'show' : ''}>
                <button class="ql-bold"><BoldOutlined /></button>
                <button class="ql-italic"><ItalicOutlined /></button>
                <button class="ql-underline"><UnderlineOutlined /></button>
              </div>

              <MenuContentPrices menuPrices={state.active?.prices} hideTrailingZeroes={props.hideTrailingZeroes} onUpdate={this.updateItemValue.bind(this)} onRemove={this.removeItem.bind(this)}
                menuObjectLayout={props.menuObjectLayout} />

              <textarea tabIndex={10} placeholder="Extras" className="field extras" spellcheck="true" autocomplete="off"
                value={state.active?.extras}
                onClick={e => this.updateItemValue('extras', e.target.value)}
                onChange={e => this.updateItemValue('extras', e.target.value)}
                onKeyDown={this.onExtrasKeydown}
              />

              <MenuContentModifiers 
                $element={this.props.$element}
                menuModifiers={state.active?.modifiers} 
                onUpdate={this.updateItemValue.bind(this)} 
                onRemove={this.removeItemModifier.bind(this)} 
                hideTrailingZeroes={props.hideTrailingZeroes}
              />

              <MenuContentEditHighlight
                activeItem={this.state.active}
              />
            </div>}

            {props.contentEditMode === "icons" &&
              <MenuIconEdit
                id={'first'}
                activeItem={state.active}
                activeIcons={state.activeIcons}
                activeIconIdx={state.activeIconIdx}
                setActiveIconIdx={this.setActiveIconIdx.bind(this)}
                editIcon={this.editIcon.bind(this)}
                clearAllIcons={this.clearAllIcons.bind(this)}
                //updateUploadsList={this.updateUploadsList.bind(this)}
                //uploadsList={state.iconUploads}
                openColorPicker={this.openColorPicker}
                setContentEditMode={props.setContentEditMode}
                uploadedIcons={props.uploadedIcons}
                setUploadedIcons={props.setUploadedIcons}
              />}
          </div>
        </div>
      </div>
    )
  }
}
